<script>
import ElDropdown from 'element-ui/packages/dropdown/src/dropdown'

export default {
  // 保留 Element 菜单项的事件派发及菜单的 provide/inject 契约。
  name: 'ElDropdown',
  extends: ElDropdown,
  beforeDestroy () {
    clearTimeout(this.timeout)
  },
  methods: {
    handleMenuItemClick (command, instance) {
      if (this.disabled || (instance && instance.disabled)) return
      ElDropdown.methods.handleMenuItemClick.call(this, command, instance)
    }
  },
  render (h) {
    const menus = this.$slots.dropdown || []
    menus.forEach(menu => {
      menu.data = menu.data || {}
      const classes = menu.data.class
      if (!Array.isArray(classes) || !classes.includes('ui-dropdown-menu')) {
        menu.data.class = [classes, 'terminal-dropdown-menu', 'ui-dropdown-menu']
      }
    })
    const vnode = ElDropdown.render.call(this, h)
    vnode.data = vnode.data || {}
    vnode.data.class = [vnode.data.class, 'ui-dropdown']
    return vnode
  }
}
</script>
